import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Requestor/";

const requestorAPIService = new APIService(baseUrl);

export async function AddRequestor(requestor) {
  var url = "addrequestor";
  return await requestorAPIService.putData(url, requestor);
}

export async function UpdateRequestor(requestor) {
  var url = "updaterequestor";
  return await requestorAPIService.patchData(url, requestor);
}

export async function DeleteRequestor(requestorId) {
  var url = "deleterequestor?requestorId=" + requestorId;
  return await requestorAPIService.deleteData(url);
}

export async function GetRequestor(requestorId) {
  var url = "getrequestorbyid?requestorId=" + requestorId;
  return await requestorAPIService.fetchData(url);
}

export async function GetRequestorByMapping(mappingId) {
  var url = "getrequestorbymappingid?mappingId=" + mappingId;
  return await requestorAPIService.fetchData(url);
}

export async function checkRequesterEmail(email) {
  var url = "checkrequestoremail?email=" + email;
  return await requestorAPIService.fetchData(url);
}

export async function AddUpdateRequestorAddress(data) {
  var url = "addrequestoradddress";
  return await requestorAPIService.postData(url, data);
}

export async function GetRequestorAddresses(requestorId) {
  var url = "getrequestoraddresses?requestorId=" + requestorId;
  return await requestorAPIService.fetchData(url);
}

export async function DeleteRequestorAddress(addressId, requestorId) {
  var url = `deleterequestoraddress?addressId=${addressId}&requestorId=${requestorId}`;
  return await requestorAPIService.fetchData(url);
}
